import actionTypes from '../../actionTypes'
import initial from '../../initial'
import global from '../../../config/global'

const project = (state = initial.project, action) => {
  switch (action.type) {
  case actionTypes.SET_PROJECTS:
    return { ...state, projects: action.payload }
  case actionTypes.SET_IS_FETCH_PROJECTS:
    return { ...state, isFetchProjects: action.payload }
  case actionTypes.SET_SELECTED_PROJECT:
    return {
      ...state,
      selectedProject: action.payload,
      isAdmin:  action.payload?.role === global.constants.PROJECT_MEMBER_ROLE.ADMIN,
      isRegular:  action.payload?.role === global.constants.PROJECT_MEMBER_ROLE.REGULAR,
      isReadOnly:  action.payload?.role === global.constants.PROJECT_MEMBER_ROLE.READ_ONLY,
    }
  case actionTypes.SET_PROJECT_SECRETS:
    return { ...state, projectSecrets: action.payload }
  case actionTypes.SET_PROJECT_ENVIRONMENTS:
    return { ...state, projectEnvironments: action.payload }
  case actionTypes.SET_IS_FETCH_PROJECT_SECRETS:
    return { ...state, isFetchProjectSecrets: action.payload }
  case actionTypes.SET_IS_FETCH_PROJECT_ENVIRONMENTS:
    return { ...state, isFetchProjectEnvironments: action.payload }
  default:
    return state
  }
}

export default project
